module.exports = __webpack_public_path__ + "img/Icon-Generosity.60b92ec9.png";